document.addEventListener('DOMContentLoaded', () => {
    const checkboxes = document.querySelectorAll('.js-agreement-form-checkbox');

    const initCheckboxes = ()=> {
        checkboxes.forEach(checkbox => {
            const button = checkbox.closest('.js-agreement-form').querySelector('.js-agreement-form-button');

            if (checkbox.checked) {
                button.classList.remove('is-state-disabled');
            } else {
                button.classList.add('is-state-disabled');
            }

            console.log('Init:' + button)
        });
    }

    const changeCheckboxes = () => {
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', (e) => {
                const button = checkbox.closest('.js-agreement-form').querySelector('.js-agreement-form-button');

                if (checkbox.checked) {
                    button.classList.remove('is-state-disabled');
                } else {
                    button.classList.add('is-state-disabled');
                }

                console.log(button)
            });
        });
    }


    initCheckboxes();
    changeCheckboxes();
});
